export const BasicInfoSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 62.983 62.983">
      <g>
        <g id="group-11svg">
          <path
            id="path-1_1_"
            d="M62.492,53.486c0,5.245-4.253,9.497-9.5,9.497h-43c-5.247,0-9.5-4.252-9.5-9.497V9.498
			C0.492,4.253,4.745,0,9.991,0h43c5.247,0,9.5,4.253,9.5,9.498V53.486z M59.492,9.498c0-3.589-2.91-6.498-6.5-6.498h-43
			c-3.59,0-6.5,2.909-6.5,6.498v43.988c0,3.588,2.91,6.498,6.5,6.498h43c3.59,0,6.5-2.91,6.5-6.498V9.498z"
          />
          <path
            id="path-2_1_"
            d="M32.846,25.339c-3.793,0-6.995-5.165-6.995-8.408c0-3.403,3.259-6.389,6.975-6.389
			s6.975,2.986,6.975,6.389C39.8,20.174,36.618,25.339,32.846,25.339z M32.826,13.542c-2.006,0-3.975,1.679-3.975,3.389
			c0,2.173,2.39,5.409,3.995,5.409c1.589,0,3.955-3.236,3.955-5.409C36.8,15.221,34.832,13.542,32.826,13.542z"
          />
          <path
            id="path-3_1_"
            d="M41.306,35.99c-0.614,0-1.168-0.175-1.394-0.747c-1.158-2.922-3.939-4.709-7.082-4.709
			c-3.101,0-5.867,1.902-7.047,4.767c-0.224,0.545-0.745,0.932-1.333,0.953l-2.256,0.094c-0.414,0.015-0.804-0.132-1.095-0.414
			c-0.294-0.282-0.459-0.668-0.459-1.075c0-6.717,5.467-12.18,12.186-12.18s12.185,5.465,12.185,12.182
			c0,0.821-0.661,1.29-1.482,1.301l-2.204-0.172C41.319,35.99,41.312,35.99,41.306,35.99z M32.826,25.68
			c-4.202,0-7.754,2.835-8.843,6.692c1.942-2.931,5.231-4.738,8.847-4.738c3.618,0,6.89,1.794,8.83,4.711
			C40.562,28.501,37.017,25.68,32.826,25.68z"
          />
          <path
            id="path-4_1_"
            d="M43.065,45.988h-21c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5h21c0.828,0,1.5,0.672,1.5,1.5
			C44.565,45.316,43.893,45.988,43.065,45.988z"
          />
          <path
            id="path-5"
            d="M43.065,52.986h-21c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5h21c0.828,0,1.5,0.672,1.5,1.5
			S43.893,52.986,43.065,52.986z"
          />
        </g>
      </g>
    </svg>
  );
};
